import React from 'react';
import PropTypes from 'prop-types';

import NewFilterButton from 'shared/filter_button';
import FilterCheckboxGroup from 'components/search_sidebar/filter_checkbox_group';

export function CheckboxFilter({
  addFilter,
  className,
  filterTag,
  label,
  name,
  options,
  removeFilter,
  selected,
  hideClearControl,
  hideSelectedCount,
  onClear,
}) {
  const handleCheckboxFilterChange = (event) => {
    const handler = event.target.checked ? addFilter : removeFilter;
    handler(name, event.target.value);
  };

  function removeFilters() {
    if (onClear) {
      onClear();
    } else {
      selected.map(option => removeFilter(name, option));
    }
  }

  const selectionTagProps = {};

  if (hideSelectedCount) {
    selectionTagProps.filtersApplied = selected.length > 0;
  } else if (filterTag) {
    selectionTagProps.filterTag = filterTag;
  } else { 
    selectionTagProps.selectedLength = selected.length;
  }

  return (
    <NewFilterButton
      {...selectionTagProps}
      className={className}
      constantWidth
      label={label}
      name={name}
      onClear={!hideClearControl && selected.length ? removeFilters : null}
    >
      <FilterCheckboxGroup
        options={options}
        selected={selected}
        onChange={handleCheckboxFilterChange}
      />
    </NewFilterButton>
  );
}

CheckboxFilter.propTypes = {
  addFilter: PropTypes.func,
  className: PropTypes.string,
  filterTag: PropTypes.string,
  hideClearControl: PropTypes.bool,
  hideSelectedCount: PropTypes.bool,
  label: PropTypes.string,
  name: PropTypes.string,
  options: PropTypes.array,
  removeFilter: PropTypes.func,
  selected: PropTypes.array,
  onClear: PropTypes.func,
};

export default CheckboxFilter;
